/** Pure helpers for Telegram Intelligence scrape-status UI (TG-2 / TG-5). */

export interface ScrapeAttempt {
    scraped_at: string | null;
    msgs_pulled: number;
    error_type?: string | null;
    error_msg?: string | null;
    scrape_kind?: string | null;
}

/** Relative age for scrape-log status chips (e.g. "2h ago"). */
export function formatRelativeAgo(iso: string | null | undefined): string {
    if (!iso) return 'never';
    const t = new Date(iso).getTime();
    if (Number.isNaN(t)) return 'unknown';
    const diffMs = Date.now() - t;
    if (diffMs < 0) return 'just now';
    const sec = Math.floor(diffMs / 1000);
    if (sec < 60) return `${sec}s ago`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m ago`;
    const hr = Math.floor(min / 60);
    if (hr < 48) return `${hr}h ago`;
    const days = Math.floor(hr / 24);
    return `${days}d ago`;
}

/** "Last scrape: 2h ago · 0 msgs · ChannelPrivateError" */
export function formatScrapeAttemptStatus(attempt: ScrapeAttempt | null | undefined): string {
    if (!attempt) return 'No scrape attempt logged';
    const parts = [
        `Last scrape: ${formatRelativeAgo(attempt.scraped_at)}`,
        `${attempt.msgs_pulled ?? 0} msgs`,
    ];
    if (attempt.error_type) parts.push(attempt.error_type);
    return parts.join(' · ');
}

export function zeroMessageDiagnostic(
    channel: string,
    attempt: ScrapeAttempt | null | undefined,
): string {
    if (!attempt) {
        return `No messages for #${channel}. No scrape attempt has been logged yet — run a scrape or deep backfill.`;
    }
    const when = formatRelativeAgo(attempt.scraped_at);
    const err = attempt.error_type ? ` (${attempt.error_type})` : '';
    if ((attempt.msgs_pulled ?? 0) === 0) {
        return `Last scrape attempt: ${when} — Telethon returned 0${err} (possible reasons: private / banned / dormant)`;
    }
    return `Last scrape attempt: ${when} · ${attempt.msgs_pulled} msgs pulled${err}. No rows match the current filters.`;
}
